export const data = [
  {
    name: 'HTML5',
    img: 'https://logospng.org/download/html-5/logo-html-5-512.png',
    utilization: [
      'HTML Semântico visando acessibilidade e altos scores de SEO.'
    ]
  },
  {
    name: 'Git | GitHub',
    img: 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Git_icon.svg/640px-Git_icon.svg.png',
    utilization: [
      'Versionamento de código e fluxo de trabalho em equipe.'
    ]
  },
  {
    name: 'CSS3',
    img: 'https://logospng.org/download/css-3/logo-css-3-512.png',
    utilization: [
      'Criação de layouts responsivos utilizando os conceitos de Mobile First;',
      'Criação de layouts utilizando Flexbox e Grid.'
    ]
  },
  {
    name: 'JavaScript',
    img: 'https://logospng.org/download/javascript/logo-javascript-icon-512.png',
    utilization: [
      'Domínio das HOFs (forEach, map, filter, find, some, every, sort, reduce);',
      'Manipulação do Web Storage;',
      'Domínio das features do ES6 (spread operator, rest parameter, destructuring, default parameter, etc);',
      'JavaScript assíncrono e callbacks (then/catch, async/await) e consumo de APIs Rest.'
    ]
  },
  {
    name: 'ReactJS',
    img: 'https://logospng.org/download/react/logo-react-512.png',
    utilization: [
      'Criação de aplicações componentizadas;',
      'Criação de SPA (Single Page Application);',
      'Manipulação de estados da aplicação e dos ciclos de vida;',
      'Criação de rotas utilizando o React Router Dom.'
    ]
  }
];

export const projects = [
  {
    name: 'Pixel Art',
    video: 'PixelArtVideo',
  },
  {
    name: 'Lista de Tarefas',
    video: 'toDoVideo',
  },
  {
    name: 'Color Guess',
    video: 'ColorGuessVideo',
  },
  {
    name: 'Trybewarts',
    video: 'TrybewartsVideo',
  },
  {
    name: 'Shoping Cart',
    video: 'ShopingCartVideo',
  },
  {
    name: 'Solar System',
    video: 'SolarSystemVideo',
  },
  {
    name: 'Tryunfo',
    video: 'TryunfoVideo',
  },
  {
    name: 'TrybeTunes',
    video: 'TrybeTunesVideo',
  }
  ,
  {
    name: 'Front-End Online Store',
    video: 'FrontEndOnStoreVideo',
  }
]

